/**
 * Shown to a signed-in user who belongs to no organisation and cannot create
 * one — for example someone whose invitation expired, or whose organisation
 * was deleted.
 *
 * Joining an organisation is invite-only by design: there is no "find my
 * organisation" search, because that would let anyone probe which churches use
 * Echo and request access to them.
 */

import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { Auth } from '@angular/fire/auth';
import { AuthenticationService } from '../../core/services/auth.service';

@Component({
    selector: 'app-no-organization',
    standalone: true,
    imports: [CommonModule, RouterLink],
    templateUrl: './no-organization.component.html'
})
export class NoOrganizationComponent {

    private auth = inject(Auth);
    private authenticationService = inject(AuthenticationService);
    private router = inject(Router);

    get email(): string {
        return this.auth.currentUser?.email ?? '';
    }

    async signOut(): Promise<void> {
        await this.authenticationService.logout();
        this.router.navigate(['/auth/login']);
    }

    contactSupport(): void {
        window.open('https://www.solenex.it/echo.html', '_blank');
    }
}
